// SemanticUI-free pre-@plone/components

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { NavLink } from 'react-router-dom';
import doesNodeContainClick from '@kitconcept/volto-light-theme/helpers/doesNodeContainClick';
import { useIntl, defineMessages, injectIntl } from 'react-intl';
import cx from 'classnames';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';

import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import clearSVG from '@plone/volto/icons/clear.svg';
import NavItem from '@plone/volto/components/theme/Navigation/NavItem';
import arrowDown from 'volto-saw-homepage/theme/assets/arrow_down.svg';
import { RiArrowDropDownFill } from 'react-icons/ri';
//'../../theme/assets/arrow-down.svg';
// import { Icon } from '@plone/volto/components';
import { useHistory } from 'react-router-dom';

const messages = defineMessages({
  closeMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openFatMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
});

const Navigation = ({ pathname }) => {
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(null);
  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);
  const navigation = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const intl = useIntl();
  const has_fat_menu = true;
  const lang = useSelector((state) => state.intl.locale);
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);
  const filtered_items = items.filter((item) => {
    return item.review_state && item.title !== 'Home';
  });

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navigation.current && doesNodeContainClick(navigation.current, e))
        return;
      closeMenu();
    };

    document.addEventListener('mousedown', handleClickOutside, false);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), config.settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  const isActive = (url) => {
    return (url === '' && pathname === '/') || (url !== '' && pathname === url);
  };

  const onFocus = (index) => {
    openMenu(index);
  };

  const openMenu = (index) => {
    setDesktopMenuOpen(index);
    setCurrentOpenIndex(index);

    // if (index === currentOpenIndex) {
    //   setDesktopMenuOpen(null);
    //   setCurrentOpenIndex(null);
    // } else {
    //   setDesktopMenuOpen(index);
    //   setCurrentOpenIndex(index);
    // }
  };

  const closeMenu = (index) => {
    setDesktopMenuOpen(null);
    setCurrentOpenIndex(null);
  };

  const navigateTo = (url) => {
    history.push(url);
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        closeMenu();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <nav
      id="navigation"
      aria-label="navigation"
      className="navigation"
      ref={navigation}
    >
      <div className={'saw computer large screen widescreen only'}>
        <ul className="desktop-menu">
          {filtered_items.map((item, index) => (
            <li
              onMouseEnter={() => openMenu(index)}
              onMouseLeave={() => closeMenu()}
              key={item.url}
              className={cx(item.review_state)}
            >
              {has_fat_menu && item.items.length > 0 ? (
                <>
                  <button
                    onFocus={() => onFocus(index)}
                    onClick={(e) => {
                      // e.stopPropagation();
                      navigateTo(item.url);
                      closeMenu();
                    }}
                    className={cx(
                      'item',
                      {
                        active:
                          desktopMenuOpen === index ||
                          (desktopMenuOpen === null &&
                            pathname.indexOf(item.url) != -1),
                      },
                      item.review_state,
                    )}
                    aria-label={intl.formatMessage(messages.openFatMenu)}
                    aria-expanded={desktopMenuOpen === index ? true : false}
                  >
                    {item.title}
                    {/* <img src={arrowDown} size="24px" /> */}
                  </button>
                  <RiArrowDropDownFill className="saw-nav-down" />
                  <div className="submenu-wrapper">
                    <div
                      className={cx('submenu', {
                        active: desktopMenuOpen === index,
                      })}
                    >
                      <div className="submenu-inner">
                        <ul>
                          {item.items &&
                            item.items.length > 0 &&
                            item.items.map((subitem) => (
                              <li
                                className={cx(
                                  'subitem-wrapper',
                                  subitem.review_state,
                                )}
                                key={subitem.url}
                              >
                                <NavLink
                                  to={subitem.url}
                                  // onClick={e => {
                                  //   e.stopPropagation();
                                  // }}
                                  onMouseEnter={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onClick={() => closeMenu()}
                                  className={cx({
                                    current: isActive(subitem.url),
                                  })}
                                >
                                  {subitem.nav_title || subitem.title}
                                </NavLink>
                                {subitem.items && subitem.items.length > 0 && (
                                  <div className="sub-submenu">
                                    <ul>
                                      {subitem.items.map((subsubitem) => (
                                        <li
                                          className="subsubitem-wrapper"
                                          className={cx(
                                            'subsubitem-wrapper',
                                            subsubitem.review_state,
                                          )}
                                          key={subsubitem.url}
                                        >
                                          <NavLink
                                            to={subsubitem.url}
                                            // onClick={() => closeMenu()}
                                            className={cx({
                                              current: isActive(subsubitem.url),
                                            })}
                                          >
                                            <span>
                                              {subsubitem.nav_title ||
                                                subsubitem.title}
                                            </span>
                                          </NavLink>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <NavItem item={item} lang={lang} key={item.url} />
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

Navigation.defaultProps = {
  token: null,
};

export default injectIntl(Navigation);
